// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Hlh0j","content":"styles_content__38nyo"};